// eslint-disable-next-line
import { UserLayout, BasicLayout,BlankLayout, RouteView,  PageView } from '@/layouts'
import * as icon from '@/core/icons'

export const asyncRouterMap = [
  {
    path: '/',
    name: 'index',
    component: BasicLayout,
    meta: { title: 'menu.home' },
    redirect: '/index/home',
    children: [
      {
        component: RouteView,
        path: '/home',
        name: 'home',
        redirect: '/index/home',
        meta: { title: '首页', icon: icon['home'], permission: ['admin', 'user'] },
        children: [
          {
            path: '/index',
            component: PageView,
            name: 'welcome',
            hideChildrenInMenu: true,
            meta: { title: '停车场概览', icon: icon['home'], keepAlive: true, permission: ['admin', 'user', 'parkingManage-dataChart'] },
            redirect: '/index/home',
            children: [
              {
                path: '/index/home',
                name: 'welcomePage',
                hideChildrenInMenu: true,
                component: () => import('@/views/parkingManage/dataChart'),
                meta: { title: '停车场概览', keepAlive: true, permission: ['admin', 'user'] }
              }
            ]
          },
          // {
          //   path: '/parkingManage',
          //   component: RouteView,
          //   name: 'ParkingManage',
          //   hideChildrenInMenu: true,
          //   redirect: '/parkingManage/dataChart',
          //   meta: { title: '停车场主页面', icon: icon['home'], keepAlive: true, permission: ['admin', 'parkingManage-dataChart'] },
          //   children: [
          //     {
          //       path: '/parkingManage/dataChart',
          //       name: 'DataChart',
          //       hideChildrenInMenu: true,
          //       component: () => import('@/views/parkingManage/dataChart'),
          //       meta: { title: '停车场主页面', keepAlive: true, permission: ['admin', 'user'] }
          //     }
          //   ]
          // },
          // {
          //   path: '/orderManage/payOrder',
          //   name: 'payOrder',
          //   hideChildrenInMenu: true,
          //   component: RouteView,
          //   redirect: '/orderManage/payOrder/list',
          //   meta: { title: '支付交易单号查询', icon: 'unordered-list', keepAlive: true, permission: ['admin', 'orderManage-payOrder'] },
          //   children: [
          //     {
          //       path: '/orderManage/payOrder/list',
          //       name: 'payOrderList',
          //       hideChildrenInMenu: true,
          //       component: () => import('@/views/orderManage/payOrder/list'),
          //       meta: { title: '支付交易单号查询', keepAlive: true, permission: ['user'] }
          //     }
          //   ]
          // },
          {
            path: '/user',
            name: 'User',
            component: RouteView,
            redirect: 'user/center',
            hidden: true,
            meta: { title: '个人设置', keepAlive: false, permission: ['admin', 'user'] },
            children: [
              {
                path: '/user/center',
                name: 'Center',
                hideChildrenInMenu: true,
                component: () => import('@/views/user/center'),
                meta: { title: '个人中心', keepAlive: false, permission: ['admin', 'user'] }
              }
            ]
          }
        ]
      },
      {
        path: '/configManage',
        name: 'ConfigManage',
        component: RouteView,
        redirect: '/configManage/chargingOrder/list',
        meta: { title: '配置中心', icon: icon['setting'], permission: ['admin', 'configCenter-parkingConfig', 'configCenter-accountConfig', 'configCenter-roleConfig', 'configCenter-deptConfig', 'configCenter-merchantConfig', 'configCenter-appConfig', 'configCenter-holidayConfig', 'distributorb-distributorListb', 'distributorb-distributorParkb', 'distributorb-distributorSettleb'] },
        children: [
          {
            path: '/configCenter',
            name: 'configCenter',
            component: RouteView,
            redirect: '/configCenter/parkingConfig/list',
            meta: { title: '车场配置', icon: 'setting', keepAlive: true, permission: ['admin', 'configCenter-parkingConfig', 'configCenter-accountConfig', 'configCenter-roleConfig', 'configCenter-deptConfig', 'configCenter-merchantConfig', 'configCenter-appConfig', 'configCenter-holidayConfig'] },
            children: [
              {
                path: '/configCenter/parkingConfig',
                component: PageView,
                name: 'parkingConfig',
                hideChildrenInMenu: true,
                meta: { title: '车场配置', icon: icon['parkingConfig'], keepAlive: true, permission: ['admin', 'configCenter-parkingConfig'] },
                redirect: '/configCenter/parkingConfig/list',
                children: [
                  {
                    path: '/configCenter/parkingConfig/list',
                    name: 'parkingConfigList',
                    hideChildrenInMenu: true,
                    component: () => import('@/views/configCenter/parkingConfig/list'),
                    meta: { title: '车场配置', keepAlive: true, permission: ['user'] }
                  },
                  {
                    path: '/configCenter/enterOutConfig/list',
                    name: 'enterOutConfig',
                    hideChildrenInMenu: false,
                    hidden: true,
                    component: () => import('@/views/configCenter/enterOutConfig/list'),
                    meta: { title: '出入口配置', keepAlive: false, permission: ['user'] }
                  },
                  {
                    path: '/configCenter/deviceConfig/list',
                    name: 'deviceConfig',
                    hideChildrenInMenu: false,
                    hidden: true,
                    component: () => import('@/views/configCenter/deviceConfig/list'),
                    meta: { title: '设备管理', keepAlive: false, permission: ['user'] }
                  },
                  {
                    path: '/configCenter/intercomConfig/list',
                    name: 'intercomConfig',
                    hideChildrenInMenu: false,
                    hidden: true,
                    component: () => import('@/views/configCenter/intercomConfig/list'),
                    meta: { title: '对讲立柱', keepAlive: false, permission: ['user'] }
                  },
                  {
                    path: '/configCenter/feeConfig/list',
                    name: 'feeConfig',
                    hideChildrenInMenu: false,
                    hidden: true,
                    component: () => import('@/views/configCenter/feeConfig/list'),
                    meta: { title: '停车场收费配置管理', keepAlive: false, permission: ['user'] }
                  },
                  {
                    path: '/configCenter/groupFeeListb/list',
                    name: 'GroupFeeListb',
                    hideChildrenInMenu: false,
                    hidden: true,
                    component: () => import('@/views/configCenter/groupFeeListb/list'),
                    meta: { title: '停车场分组计费管理', keepAlive: false, permission: ['user'] }
                  },
                  {
                    path: '/configCenter/groupFeeListb/carOwnerList',
                    name: 'CarOwnerList',
                    hideChildrenInMenu: false,
                    hidden: true,
                    component: () => import('@/views/configCenter/groupFeeListb/carOwnerList'),
                    meta: { title: '分组计费-车主管理', keepAlive: false, permission: ['user'] }
                  },
                  {
                    path: '/configCenter/groupFeeListb/carList',
                    name: 'CarList',
                    hideChildrenInMenu: false,
                    hidden: true,
                    component: () => import('@/views/configCenter/groupFeeListb/carList'),
                    meta: { title: '分组计费-车辆管理', keepAlive: false, permission: ['user'] }
                  },
                  {
                    path: '/configCenter/feeStepConfig/list',
                    name: 'feeStepConfig',
                    hideChildrenInMenu: false,
                    hidden: true,
                    component: () => import('@/views/configCenter/feeStepConfig/list'),
                    meta: { title: '阶梯计费区间管理', keepAlive: false, permission: ['user'] }
                  },
                  {
                    path: '/configCenter/feeTimeStepTimeConfig/list',
                    name: 'feeTimeStepTimeConfig',
                    hideChildrenInMenu: false,
                    hidden: true,
                    component: () => import('@/views/configCenter/feeTimeStepTimeConfig/list'),
                    meta: { title: '分时阶梯分时区间管理', keepAlive: false, permission: ['user'] }
                  },
                  {
                    path: '/configCenter/feeTimeStepStepConfig/list',
                    name: 'feeTimeStepStepConfig',
                    hideChildrenInMenu: false,
                    hidden: true,
                    component: () => import('@/views/configCenter/feeTimeStepStepConfig/list'),
                    meta: { title: '分时阶梯阶梯区间管理', keepAlive: false, permission: ['user'] }
                  },
                  {
                    path: '/configCenter/thirdCloudAccountConfig/list',
                    name: 'thirdCloudAccountConfig',
                    hideChildrenInMenu: false,
                    hidden: true,
                    component: () => import('@/views/configCenter/thirdCloudAccountConfig/list'),
                    meta: { title: '相机云账号配置', keepAlive: false, permission: ['user'] }
                  }
                ]
              },
              {
                path: '/configCenter/accountConfig',
                component: PageView,
                name: 'AccountConfig',
                hideChildrenInMenu: true,
                meta: { title: '账号配置', icon: icon['accountConfig'], keepAlive: true, permission: ['admin', 'configCenter-accountConfig'] },
                redirect: '/configCenter/accountConfig/list',
                children: [
                  {
                    path: '/configCenter/accountConfig/list',
                    name: 'AccountConfigList',
                    hideChildrenInMenu: true,
                    component: () => import('@/views/configCenter/accountConfig/list'),
                    meta: { title: '账号配置', keepAlive: true, permission: ['user'] }
                  }
                ]
              },
              {
                path: '/configCenter/roleConfig',
                component: PageView,
                name: 'RoleConfig',
                hideChildrenInMenu: true,
                meta: { title: '角色配置', icon: 'usergroup-add', keepAlive: true, permission: ['admin', 'configCenter-roleConfig'] },
                redirect: '/configCenter/roleConfig/list',
                children: [
                  {
                    path: '/configCenter/roleConfig/list',
                    name: 'RoleConfigList',
                    hideChildrenInMenu: true,
                    component: () => import('@/views/configCenter/roleConfig/list'),
                    meta: { title: '角色配置', keepAlive: true, permission: ['user'] }
                  },
                  {
                    path: '/configCenter/roleConfig/addUser',
                    name: 'AddUser',
                    hidden: true,
                    hideChildrenInMenu: true,
                    component: () => import('@/views/configCenter/roleConfig/addUser'),
                    meta: { title: '新增用户', keepAlive: false, permission: ['user'] }
                  }
                ]
              },
              {
                path: '/configCenter/deptConfig',
                component: PageView,
                name: 'DeptConfig',
                hideChildrenInMenu: true,
                meta: { title: '企业配置', icon: icon['deptConfig'], keepAlive: true, permission: ['admin', 'configCenter-deptConfig'] },
                redirect: '/configCenter/deptConfig/list',
                children: [
                  {
                    path: '/configCenter/deptConfig/list',
                    name: 'DeptConfigList',
                    hideChildrenInMenu: true,
                    component: () => import('@/views/configCenter/deptConfig/list'),
                    meta: { title: '企业配置', keepAlive: true, permission: ['user'] }
                  }
                ]
              },
              {
                path: '/configCenter/merchantConfig',
                component: PageView,
                name: 'MerchantConfig',
                hideChildrenInMenu: true,
                meta: { title: '支付商户管理', icon: 'shop', keepAlive: true, permission: ['admin', 'configCenter-merchantConfig'] },
                redirect: '/configCenter/merchantConfig/list',
                children: [
                  {
                    path: '/configCenter/merchantConfig/list',
                    name: 'MerchantConfigList',
                    hideChildrenInMenu: true,
                    component: () => import('@/views/configCenter/merchantConfig/list'),
                    meta: { title: '支付商户管理', keepAlive: true, permission: ['user'] }
                  }
                ]
              },
              {
                path: '/configCenter/appConfig',
                component: PageView,
                name: 'AppConfig',
                hideChildrenInMenu: true,
                meta: { title: '小程序配置', icon: icon['appConfig'], keepAlive: true, permission: ['admin', 'configCenter-appConfig'] },
                redirect: '/configCenter/appConfig/list',
                children: [
                  {
                    path: '/configCenter/appConfig/list',
                    name: 'AppConfigList',
                    hideChildrenInMenu: true,
                    component: () => import('@/views/configCenter/appConfig/list'),
                    meta: { title: '小程序配置', keepAlive: true, permission: ['user'] }
                  },
                  {
                    path: '/configCenter/appConfig/addOrUpdate',
                    name: 'AppConfigAddOrUpdate',
                    hideChildrenInMenu: true,
                    hidden: true,
                    component: () => import('@/views/configCenter/appConfig/addOrUpdate'),
                    meta: { title: '新增/编辑小程序', keepAlive: false, permission: ['user'] }
                  },
                  {
                    path: '/configCenter/appConfig/editConfig',
                    name: 'AppConfigEditConfig',
                    hideChildrenInMenu: true,
                    hidden: true,
                    component: () => import('@/views/configCenter/appConfig/editConfig'),
                    meta: { title: '小程序配置', keepAlive: false, permission: ['user'] }
                  }
                ]
              },
              {
                path: '/configCenter/holidayConfig',
                component: PageView,
                name: 'HolidayConfig',
                hideChildrenInMenu: true,
                meta: { title: '节假日配置', icon: 'calendar', keepAlive: true, permission: ['admin', 'configCenter-holidayConfig'] },
                redirect: '/configCenter/holidayConfig/list',
                children: [
                  {
                    path: '/configCenter/holidayConfig/list',
                    name: 'HolidayConfigList',
                    hideChildrenInMenu: true,
                    component: () => import('@/views/configCenter/holidayConfig/list'),
                    meta: { title: '节假日配置', keepAlive: true, permission: ['user'] }
                  }
                ]
              }
            ]
          }
          // {
          //   path: '/distributorb',
          //   name: 'Distributorb',
          //   component: RouteView,
          //   redirect: '/distributorb/distributorListb/list',
          //   meta: { title: '平台分润配置', keepAlive: true, permission: ['admin', 'distributorb-distributorListb', 'distributorb-distributorParkb', 'distributorb-distributorSettleb'] },
          //   children: [
          //     {
          //       path: '/distributorb/distributorListb',
          //       component: RouteView,
          //       name: 'DistributorListb',
          //       hideChildrenInMenu: true,
          //       meta: { title: '分润商户配置', icon: 'setting', keepAlive: true, permission: ['admin', 'distributorb-distributorListb'] },
          //       redirect: '/distributorb/distributorListb/list',
          //       children: [
          //         {
          //           path: '/distributorb/distributorListb/list',
          //           name: 'DistributorListbList',
          //           hideChildrenInMenu: true,
          //           component: () => import('@/views/distributorb/distributorListb/list'),
          //           meta: { title: '分润商户配置', keepAlive: true, permission: ['user'] }
          //         }
          //       ]
          //     },
          //     {
          //       path: '/distributorb/distributorParkb',
          //       component: RouteView,
          //       name: 'DistributorParkb',
          //       hideChildrenInMenu: true,
          //       meta: { title: '分润商户与车场配置', icon: 'tags', keepAlive: true, permission: ['admin', 'distributorb-distributorParkb'] },
          //       redirect: '/distributorb/distributorParkb/list',
          //       children: [
          //         {
          //           path: '/distributorb/distributorParkb/list',
          //           name: 'DistributorParkbList',
          //           hideChildrenInMenu: true,
          //           component: () => import('@/views/distributorb/distributorParkb/list'),
          //           meta: { title: '分润商户与车场配置', keepAlive: true, permission: ['user'] }
          //         }
          //       ]
          //     },
          //     {
          //       path: '/distributorb/distributorSettleb',
          //       component: RouteView,
          //       name: 'DistributorSettleb',
          //       hideChildrenInMenu: true,
          //       meta: { title: '分润商户提现账单', icon: 'money-collect', keepAlive: true, permission: ['admin', 'distributorb-distributorSettleb'] },
          //       redirect: '/distributorb/distributorSettleb/list',
          //       children: [
          //         {
          //           path: '/distributorb/distributorSettleb/list',
          //           name: 'DistributorSettlebList',
          //           hideChildrenInMenu: true,
          //           component: () => import('@/views/distributorb/distributorSettleb/list'),
          //           meta: { title: '分润商户提现账单', keepAlive: true, permission: ['user'] }
          //         }
          //       ]
          //     }
          //   ]
          // }
        ]
      },
      {
        path: '/operation',
        name: 'Operation',
        component: RouteView,
        redirect: '/orderManage/inOrder/list',
        meta: { title: '运营数据', icon: icon['operation'], permission: ['admin', 'orderManage-inOrder', 'orderManage-outOrder', 'orderManage-arrearsOrder', 'orderManage-recoverOrder', 'orderManage-drainageOrders', 'orderManage-blockedLog', 'orderManage-AbnormalUp', 'orderManage-chargeReduce', 'orderManage-invoiceLog', 'statistics-dayReport', 'statistics-monthReport', 'statistics-incomestat', 'statistics-longtermstat', 'statistics-hourlyCard', 'statistics-sessionCard', 'statistics-trafficstat', 'statistics-typeStaticReport', 'statistics-summaryReport', 'statistics-workReport'] },
        children: [
          {
            path: '/orderManage',
            name: 'orderManage',
            component: RouteView,
            redirect: '/orderManage/inOrder/list',
            meta: { title: '车辆订单', icon: 'profile', keepAlive: true, permission: ['admin', 'orderManage-inOrder', 'orderManage-outOrder', 'orderManage-arrearsOrder', 'orderManage-recoverOrder', 'orderManage-drainageOrders', 'orderManage-blockedLog', 'orderManage-AbnormalUp', 'orderManage-chargeReduce', 'orderManage-invoiceLog'] },
            children: [
              {
                path: '/orderManage/inOrder',
                component: PageView,
                name: 'InOrder',
                hideChildrenInMenu: true,
                meta: { title: '场内订单', icon: icon['inOrder'], keepAlive: true, permission: ['admin', 'orderManage-inOrder'] },
                redirect: '/orderManage/inOrder/list',
                children: [
                  {
                    path: '/orderManage/inOrder/list',
                    name: 'InOrderList',
                    hideChildrenInMenu: true,
                    component: () => import('@/views/orderManage/inOrder/list'),
                    meta: { title: '场内订单', keepAlive: true, permission: ['user'] }
                  },
                  {
                    path: '/orderManage/inOrder/orderDetail',
                    name: 'OrderDetail',
                    hideChildrenInMenu: true,
                    hidden: true,
                    component: () => import('@/views/orderManage/inOrder/orderDetail'),
                    meta: { title: '订单详情', keepAlive: false, permission: ['user'] }
                  },
                  {
                    path: '/orderManage/inOrder/parkInfoImportb',
                    name: 'parkInfoImportb',
                    hideChildrenInMenu: true,
                    hidden: true,
                    component: () => import('@/views/orderManage/inOrder/parkInfoImportb'),
                    meta: { title: '场内订单导入', keepAlive: false, permission: ['user'] }
                  },
                  {
                    path: '/orderManage/inOrder/clearImport',
                    name: 'clearImport',
                    hideChildrenInMenu: true,
                    hidden: true,
                    component: () => import('@/views/orderManage/inOrder/clearImport'),
                    meta: { title: '场内车批量清理', keepAlive: false, permission: ['user'] }
                  },
                  {
                    path: '/orderManage/inOrder/manualOrder',
                    name: 'ManualOrder',
                    hideChildrenInMenu: true,
                    hidden: true,
                    component: () => import('@/views/orderManage/inOrder/manualOrder'),
                    meta: { title: '场内车辆清理记录', keepAlive: true, permission: ['user'] }
                  }
                ]
              },
              {
                path: '/orderManage/outOrder',
                component: PageView,
                name: 'OutOrder',
                hideChildrenInMenu: true,
                meta: { title: '出场订单', icon: icon['outOrder'], keepAlive: true, permission: ['admin', 'orderManage-outOrder'] },
                redirect: '/orderManage/outOrder/list',
                children: [
                  {
                    path: '/orderManage/outOrder/list',
                    name: 'OutOrderList',
                    hideChildrenInMenu: true,
                    component: () => import('@/views/orderManage/outOrder/list'),
                    meta: { title: '出场订单', keepAlive: true, permission: ['user'] }
                  }
                ]
              },
              {
                path: '/orderManage/arrearsOrder',
                component: PageView,
                name: 'ArrearsOrder',
                hideChildrenInMenu: true,
                meta: { title: '欠费订单', icon: icon['arrearsOrder'], keepAlive: true, permission: ['admin', 'orderManage-arrearsOrder'] },
                redirect: '/orderManage/arrearsOrder/list',
                children: [
                  {
                    path: '/orderManage/arrearsOrder/list',
                    name: 'ArrearsOrderList',
                    hideChildrenInMenu: true,
                    component: () => import('@/views/orderManage/arrearsOrder/list'),
                    meta: { title: '欠费订单', keepAlive: true, permission: ['user'] }
                  },
                  {
                    path: '/orderManage/arrearsOrder/manualArrears',
                    name: 'ManualArrears',
                    hidden: true,
                    hideChildrenInMenu: true,
                    component: () => import('@/views/orderManage/arrearsOrder/manualArrears'),
                    meta: { title: '已清理欠费订单', keepAlive: true, permission: ['user'] }
                  },
                  {
                    path: '/orderManage/arrearsOrder/revokeArrears',
                    name: 'RevokeArrears',
                    hidden: true,
                    hideChildrenInMenu: true,
                    component: () => import('@/views/orderManage/arrearsOrder/revokeArrears'),
                    meta: { title: '已撤销欠费订单', keepAlive: false, permission: ['user'] }
                  }
                ]
              },
              {
                path: '/orderManage/recoverOrder',
                component: PageView,
                name: 'RecoverOrder',
                hideChildrenInMenu: true,
                meta: { title: '追缴订单', icon: 'profile', keepAlive: true, permission: ['admin', 'orderManage-recoverOrder'] },
                redirect: '/orderManage/recoverOrder/list',
                children: [
                  {
                    path: '/orderManage/recoverOrder/list',
                    name: 'RecoverOrderList',
                    hideChildrenInMenu: true,
                    component: () => import('@/views/orderManage/recoverOrder/list'),
                    meta: { title: '追缴订单', keepAlive: true, permission: ['user'] }
                  }
                ]
              },
              // {
              //   path: '/orderManage/drainageOrders',
              //   component: PageView,
              //   name: 'DrainageOrders',
              //   hideChildrenInMenu: true,
              //   meta: { title: '车位引流订单', icon: 'deployment-unit', keepAlive: true, permission: ['admin', 'orderManage-drainageOrders'] },
              //   redirect: '/orderManage/drainageOrders/list',
              //   children: [
              //     {
              //       path: '/orderManage/drainageOrders/list',
              //       name: 'DrainageOrdersList',
              //       hideChildrenInMenu: true,
              //       component: () => import('@/views/orderManage/drainageOrders/list'),
              //       meta: { title: '车位引流订单', keepAlive: true, permission: ['user'] }
              //     }
              //   ]
              // },
              {
                path: '/orderManage/blockedLog',
                component: PageView,
                name: 'BlockedLog',
                hideChildrenInMenu: true,
                meta: { title: '车道拦截记录', icon: icon['blockedLog'], keepAlive: true, permission: ['admin', 'orderManage-blockedLog'] },
                redirect: '/orderManage/blockedLog/list',
                children: [
                  {
                    path: '/orderManage/blockedLog/list',
                    name: 'BlockedLogList',
                    hideChildrenInMenu: true,
                    component: () => import('@/views/orderManage/blockedLog/list'),
                    meta: { title: '车道拦截记录', keepAlive: true, permission: ['user'] }
                  }
                ]
              },
              {
                path: '/orderManage/AbnormalUp',
                component: PageView,
                name: 'AbnormalUp',
                hideChildrenInMenu: true,
                meta: { title: '抬杆放行减免订单', icon: icon['AbnormalUp'], keepAlive: true, permission: ['admin', 'orderManage-AbnormalUp'] },
                redirect: '/orderManage/AbnormalUp/list',
                children: [
                  {
                    path: '/orderManage/AbnormalUp/list',
                    name: 'AbnormalUpList',
                    hideChildrenInMenu: true,
                    component: () => import('@/views/orderManage/AbnormalUp/list'),
                    meta: { title: '抬杆放行减免订单', keepAlive: true, permission: ['user'] }
                  }
                ]
              },
              {
                path: '/orderManage/chargeReduce',
                component: PageView,
                name: 'ChargeReduce',
                hideChildrenInMenu: true,
                meta: { title: '充电减免明细', icon: 'reconciliation', keepAlive: true, permission: ['admin', 'orderManage-chargeReduce'] },
                redirect: '/orderManage/chargeReduce/list',
                children: [
                  {
                    path: '/orderManage/chargeReduce/list',
                    name: 'ChargeReduceList',
                    hideChildrenInMenu: true,
                    component: () => import('@/views/orderManage/chargeReduce/list'),
                    meta: { title: '充电减免明细', keepAlive: true, permission: ['user'] }
                  }
                ]
              },
              {
                path: '/orderManage/invoiceLog',
                component: PageView,
                name: 'InvoiceLog',
                hideChildrenInMenu: true,
                meta: { title: '历史开票记录', icon: 'file-search', keepAlive: true, permission: ['admin', 'orderManage-invoiceLog'] },
                redirect: '/orderManage/invoiceLog/list',
                children: [
                  {
                    path: '/orderManage/invoiceLog/list',
                    name: 'InvoiceLogList',
                    hideChildrenInMenu: true,
                    component: () => import('@/views/orderManage/invoiceLog/list'),
                    meta: { title: '历史开票记录', keepAlive: true, permission: ['user'] }
                  },
                  {
                    path: '/orderManage/invoiceLog/detail',
                    name: 'InvoiceDetail',
                    hideChildrenInMenu: true,
                    hidden: true,
                    component: () => import('@/views/orderManage/invoiceLog/detail'),
                    meta: { title: '开票详情', keepAlive: false, permission: ['user'] }
                  }
                ]
              }
            ]
          },
          {
            path: '/statistics',
            name: 'Statistics',
            component: RouteView,
            redirect: '/statistics/dayReport/list',
            meta: { title: '统计报表', icon: 'project', keepAlive: true, permission: ['admin', 'statistics-dayReport', 'statistics-monthReport', 'statistics-incomestat', 'statistics-longtermstat', 'statistics-hourlyCard', 'statistics-sessionCard', 'statistics-trafficstat', 'statistics-typeStaticReport', 'statistics-summaryReport', 'statistics-workReport'] },
            children: [
              {
                path: '/statistics/dayReport',
                component: PageView,
                name: 'DayReport',
                hideChildrenInMenu: true,
                meta: { title: '统计日报表', icon: icon['dayReport'], keepAlive: true, permission: ['admin', 'statistics-dayReport'] },
                redirect: '/statistics/dayReport/list',
                children: [
                  {
                    path: '/statistics/dayReport/list',
                    name: 'DayReportList',
                    hideChildrenInMenu: true,
                    component: () => import('@/views/statistics/dayReport/list'),
                    meta: { title: '统计日报表', keepAlive: true, permission: ['user'] }
                  }
                ]
              },
              {
                path: '/statistics/monthReport',
                component: PageView,
                name: 'MonthReport',
                hideChildrenInMenu: true,
                meta: { title: '收费月报表', icon: icon['monthReport'], keepAlive: true, permission: ['admin', 'statistics-monthReport'] },
                redirect: '/statistics/monthReport/list',
                children: [
                  {
                    path: '/statistics/monthReport/list',
                    name: 'MonthReportList',
                    hideChildrenInMenu: true,
                    component: () => import('@/views/statistics/monthReport/list'),
                    meta: { title: '收费月报表', keepAlive: true, permission: ['admin', 'user'] }
                  }
                ]
              },
              {
                path: '/statistics/incomestat',
                component: PageView,
                name: 'Incomestat',
                hideChildrenInMenu: true,
                meta: { title: '临停收入报表', icon: icon['incomestat'], keepAlive: true, permission: ['admin', 'statistics-incomestat'] },
                redirect: '/statistics/incomestat/list',
                children: [
                  {
                    path: '/statistics/incomestat/list',
                    name: 'IncomestatList',
                    hideChildrenInMenu: true,
                    component: () => import('@/views/statistics/incomestat/list'),
                    meta: { title: '临停收入报表', keepAlive: true, permission: ['admin', 'user'] }
                  },
                  {
                    path: '/statistics/incomestat/cashList',
                    name: 'CashList',
                    hideChildrenInMenu: true,
                    component: () => import('@/views/statistics/incomestat/cashList'),
                    meta: { title: '金额明细报表', keepAlive: false, permission: ['admin', 'user'] }
                  },
                  {
                    path: '/statistics/incomestat/reductionList',
                    name: 'ReductionList',
                    hideChildrenInMenu: true,
                    component: () => import('@/views/statistics/incomestat/reductionList'),
                    meta: { title: '减免明细报表', keepAlive: false, permission: ['admin', 'user'] }
                  }
                ]
              },
              {
                path: '/statistics/longtermstat',
                component: PageView,
                name: 'Longtermstat',
                hideChildrenInMenu: true,
                meta: { title: '月租收入报表', icon: icon['longtermstat'], keepAlive: true, permission: ['admin', 'statistics-longtermstat'] },
                redirect: '/statistics/longtermstat/list',
                children: [
                  {
                    path: '/statistics/longtermstat/list',
                    name: 'LongtermstatList',
                    hideChildrenInMenu: true,
                    component: () => import('@/views/statistics/longtermstat/list'),
                    meta: { title: '月租收入报表', keepAlive: true, permission: ['admin', 'user'] }
                  },
                  {
                    path: '/statistics/longtermstat/useList',
                    name: 'Longtermstat_useList',
                    hideChildrenInMenu: true,
                    hidden: true,
                    component: () => import('@/views/statistics/longtermstat/useList'),
                    meta: { title: '月租核销明细', keepAlive: false, permission: ['user'] }
                  }
                ]
              },
              {
                path: '/statistics/hourlyCard',
                component: PageView,
                name: 'HourlyCard',
                hideChildrenInMenu: true,
                meta: { title: '小时包收入报表', icon: 'dollar', keepAlive: true, permission: ['admin', 'statistics-hourlyCard'] },
                redirect: '/statistics/hourlyCard/list',
                children: [
                  {
                    path: '/statistics/hourlyCard/list',
                    name: 'HourlyCardList',
                    hideChildrenInMenu: true,
                    component: () => import('@/views/statistics/hourlyCard/list'),
                    meta: { title: '小时包收入报表', keepAlive: true, permission: ['admin', 'user'] }
                  },
                  {
                    path: '/statistics/hourlyCard/useList',
                    name: 'HourlyCardUseList',
                    hideChildrenInMenu: true,
                    hidden: true,
                    component: () => import('@/views/statistics/hourlyCard/useList'),
                    meta: { title: '小时包核销明细', keepAlive: false, permission: ['user'] }
                  }
                ]
              },
              {
                path: '/statistics/sessionCard',
                component: PageView,
                name: 'SessionCard',
                hideChildrenInMenu: true,
                meta: { title: '次卡收入报表', icon: 'account-book', keepAlive: true, permission: ['admin', 'statistics-sessionCard'] },
                redirect: '/statistics/sessionCard/list',
                children: [
                  {
                    path: '/statistics/sessionCard/list',
                    name: 'SessionCardList',
                    hideChildrenInMenu: true,
                    component: () => import('@/views/statistics/sessionCard/list'),
                    meta: { title: '次卡收入报表', keepAlive: true, permission: ['admin', 'user'] }
                  },
                  {
                    path: '/statistics/sessionCard/useList',
                    name: 'SessionCardUseList',
                    hideChildrenInMenu: true,
                    hidden: true,
                    component: () => import('@/views/statistics/sessionCard/useList'),
                    meta: { title: '次卡核销明细', keepAlive: false, permission: ['user'] }
                  }
                ]
              },
              {
                path: '/statistics/trafficstat',
                component: PageView,
                name: 'Trafficstat',
                hideChildrenInMenu: true,
                meta: { title: '车流数据分析', icon: icon['trafficstat'], keepAlive: true, permission: ['admin', 'statistics-trafficstat'] },
                redirect: '/statistics/trafficstat/list',
                children: [
                  {
                    path: '/statistics/trafficstat/list',
                    name: 'TrafficstatList',
                    hideChildrenInMenu: true,
                    component: () => import('@/views/statistics/trafficstat/list'),
                    meta: { title: '车流数据分析', keepAlive: true, permission: ['admin', 'user'] }
                  }
                ]
              },
              {
                path: '/statistics/typeStaticReport',
                component: PageView,
                name: 'TypeStaticReport',
                hideChildrenInMenu: true,
                meta: { title: '车道级实收报表', icon: icon['typeStaticReport'], keepAlive: true, permission: ['admin', 'statistics-typeStaticReport'] },
                redirect: '/statistics/typeStaticReport/list',
                children: [
                  {
                    path: '/statistics/typeStaticReport/list',
                    name: 'TypeStaticReportList',
                    hideChildrenInMenu: true,
                    component: () => import('@/views/statistics/typeStaticReport/list'),
                    meta: { title: '车道级实收报表', keepAlive: true, permission: ['admin', 'user'] }
                  }
                ]
              },
              {
                path: '/statistics/summaryReport',
                component: PageView,
                name: 'SummaryReport',
                hideChildrenInMenu: true,
                meta: { title: '场库核销汇总', icon: icon['summaryReport'], keepAlive: true, permission: ['admin', 'statistics-summaryReport'] },
                redirect: '/statistics/summaryReport/list',
                children: [
                  {
                    path: '/statistics/summaryReport/list',
                    name: 'SummaryReportList',
                    hideChildrenInMenu: true,
                    component: () => import('@/views/statistics/summaryReport/list'),
                    meta: { title: '场库核销汇总', keepAlive: true, permission: ['admin', 'user'] }
                  }
                ]
              },
              {
                path: '/statistics/workReport',
                component: PageView,
                name: 'WorkReport',
                hideChildrenInMenu: true,
                meta: { title: '交接班统计', icon: 'contacts', keepAlive: true, permission: ['admin', 'statistics-workReport'] },
                redirect: '/statistics/workReport/list',
                children: [
                  {
                    path: '/statistics/workReport/list',
                    name: 'WorkReportList',
                    hideChildrenInMenu: true,
                    component: () => import('@/views/statistics/workReport/list'),
                    meta: { title: '交接班统计', keepAlive: true, permission: ['admin', 'user'] }
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        path: '/businessCenter',
        name: 'BusinessCenter',
        component: RouteView,
        redirect: '/longterm/longtermProduct/list',
        meta: { title: '业务办理', icon: icon['businessCenter'], permission: ['admin', 'longterm-longtermProduct', 'longterm-longtermUser', 'longterm-longtermOrder', 'longterm-longtermUserModify', 'longterm-longtermCard', 'longterm-longtermImport', 'merchant-buyMerchant', 'merchant-activityManage', 'merchant-couponManage', 'merchant-couponUselog', 'otherBusiness-tempDerateListb', 'otherBusiness-yuandianReservation', 'otherBusiness-whitelistpageb', 'otherBusiness-blacklistpageb'] },
        children: [
          {
            path: '/longterm',
            name: 'Longterm',
            component: RouteView,
            redirect: '/longterm/longtermProduct/list',
            meta: { title: '月租车办理', icon: 'credit-card', keepAlive: true, permission: ['admin', 'longterm-longtermProduct', 'longterm-longtermUser', 'longterm-longtermOrder', 'longterm-longtermUserModify', 'longterm-longtermCard', 'longterm-longtermImport'] },
            children: [
              {
                path: '/longterm/longtermProduct',
                component: PageView,
                name: 'LongtermProduct',
                hideChildrenInMenu: true,
                meta: { title: '月卡套餐管理', icon: icon['longtermProduct'], keepAlive: true, permission: ['admin', 'longterm-longtermProduct'] },
                redirect: '/longterm/longtermProduct/list',
                children: [
                  {
                    path: '/longterm/longtermProduct/list',
                    name: 'LongtermProductList',
                    hideChildrenInMenu: true,
                    component: () => import('@/views/longterm/longtermProduct/list'),
                    meta: { title: '月卡套餐管理', keepAlive: true, permission: ['user'] }
                  }
                ]
              },
              {
                path: '/longterm/longtermUser',
                component: PageView,
                name: 'LongtermUser',
                hideChildrenInMenu: true,
                meta: { title: '车主办卡/续费', icon: icon['longtermUser'], keepAlive: true, permission: ['admin', 'longterm-longtermUser'] },
                redirect: '/longterm/longtermUser/list',
                children: [
                  {
                    path: '/longterm/longtermUser/list',
                    name: 'LongtermUserList',
                    hideChildrenInMenu: true,
                    component: () => import('@/views/longterm/longtermUser/list'),
                    meta: { title: '车主办卡/续费', keepAlive: true, permission: ['user'] }
                  },
                  {
                    path: '/longterm/longtermUser/detail',
                    name: 'LongtermUserDetail',
                    hideChildrenInMenu: true,
                    hidden: true,
                    component: () => import('@/views/longterm/longtermUser/longtermUserDetail'),
                    meta: { title: '用户详情', keepAlive: false, permission: ['user'] }
                  },
                  {
                    path: '/longterm/longtermUser/orderDetail',
                    name: 'LongtermOrderDetail',
                    hideChildrenInMenu: true,
                    hidden: true,
                    component: () => import('@/views/orderManage/inOrder/orderDetail'),
                    meta: { title: '订单详情', keepAlive: false, permission: ['user'] }
                  }
                ]
              },
              {
                path: '/longterm/longtermOrder',
                component: PageView,
                name: 'LongtermOrder',
                hideChildrenInMenu: true,
                meta: { title: '办卡记录/审核', icon: icon['longtermOrder'], keepAlive: true, permission: ['admin', 'longterm-longtermOrder'] },
                redirect: '/longterm/longtermOrder/list',
                children: [
                  {
                    path: '/longterm/longtermOrder/list',
                    name: 'LongtermOrderList',
                    hideChildrenInMenu: true,
                    component: () => import('@/views/longterm/longtermOrder/list'),
                    meta: { title: '办卡记录/审核', keepAlive: true, permission: ['user'] }
                  }
                ]
              },
              {
                path: '/longterm/longtermUserModify',
                component: PageView,
                name: 'LongtermUserModify',
                hideChildrenInMenu: true,
                meta: { title: '车辆变更审核记录', icon: icon['longtermUserModify'], keepAlive: true, permission: ['admin', 'longterm-longtermUserModify'] },
                redirect: '/longterm/longtermUserModify/list',
                children: [
                  {
                    path: '/longterm/longtermUserModify/list',
                    name: 'LongtermUserModifyList',
                    hideChildrenInMenu: true,
                    component: () => import('@/views/longterm/longtermUserModify/list'),
                    meta: { title: '车辆变更审核记录', keepAlive: true, permission: ['user'] }
                  },
                  {
                    path: '/longterm/longtermUserModify/detail',
                    name: 'LongtermUserModifyDetail',
                    hideChildrenInMenu: true,
                    hidden: true,
                    component: () => import('@/views/longterm/longtermUserModify/detail'),
                    meta: { title: '信息变更详情', keepAlive: false, permission: ['user'] }
                  }
                ]
              },
              {
                path: '/longterm/longtermCard',
                component: PageView,
                name: 'LongtermCard',
                hideChildrenInMenu: true,
                meta: { title: '月卡管理', icon: icon['longtermCard'], keepAlive: true, permission: ['admin', 'longterm-longtermCard'] },
                redirect: '/longterm/longtermCard/list',
                children: [
                  {
                    path: '/longterm/longtermCard/list',
                    name: 'LongtermCardList',
                    hideChildrenInMenu: true,
                    component: () => import('@/views/longterm/longtermCard/list'),
                    meta: { title: '月卡管理', keepAlive: true, permission: ['user'] }
                  },
                  {
                    path: '/longterm/longtermCard/detail',
                    name: 'longtermCardUser',
                    hideChildrenInMenu: true,
                    hidden: true,
                    component: () => import('@/views/longterm/longtermUser/longtermUserDetail'),
                    meta: { title: '车主详情', keepAlive: false, permission: ['user'] }
                  }
                ]
              },
              {
                path: '/longterm/longtermImport',
                component: PageView,
                name: 'LongtermImport',
                hideChildrenInMenu: true,
                meta: { title: '月租车辆导入', icon: icon['longtermImport'], keepAlive: true, permission: ['admin', 'longterm-longtermImport'] },
                redirect: '/longterm/longtermImport/list',
                children: [
                  {
                    path: '/longterm/longtermImport/list',
                    name: 'LongtermImportList',
                    hideChildrenInMenu: true,
                    component: () => import('@/views/longterm/longtermImport/list'),
                    meta: { title: '月租车辆导入', keepAlive: true, permission: ['user'] }
                  }
                ]
              }
            ]
          },
          {
            path: '/merchant',
            name: 'Merchant',
            component: RouteView,
            redirect: '/merchant/buyMerchant/list',
            meta: { title: '优惠券办理', icon: 'gift', keepAlive: true, permission: ['admin', 'merchant-buyMerchant', 'merchant-activityManage', 'merchant-couponManage', 'merchant-couponUselog'] },
            children: [
              {
                path: '/merchant/buyMerchant',
                component: PageView,
                name: 'BuyMerchant',
                hideChildrenInMenu: true,
                meta: { title: '优惠券商户', icon: 'red-envelope', keepAlive: true, permission: ['admin', 'merchant-buyMerchant'] },
                redirect: '/merchant/buyMerchant/list',
                children: [
                  {
                    path: '/merchant/buyMerchant/list',
                    name: 'BuyMerchantList',
                    hideChildrenInMenu: true,
                    component: () => import('@/views/merchant/buyMerchant/list'),
                    meta: { title: '优惠券商户', keepAlive: true, permission: ['user'] }
                  }
                ]
              },
              {
                path: '/merchant/couponManage',
                component: PageView,
                name: 'CouponManage',
                hideChildrenInMenu: true,
                meta: { title: '优惠券管理', icon: icon['couponManage'], keepAlive: true, permission: ['admin', 'merchant-couponManage'] },
                redirect: '/merchant/couponManage/list',
                children: [
                  {
                    path: '/merchant/couponManage/list',
                    name: 'CouponManageList',
                    hideChildrenInMenu: true,
                    component: () => import('@/views/merchant/couponManage/list'),
                    meta: { title: '优惠券管理', keepAlive: true, permission: ['user'] }
                  }
                ]
              },
              {
                path: '/merchant/activityManage',
                component: PageView,
                name: 'ActivityManage',
                hideChildrenInMenu: true,
                meta: { title: '营销活动', icon: icon['activityManage'], keepAlive: true, permission: ['admin', 'merchant-activityManage'] },
                redirect: '/merchant/activityManage/list',
                children: [
                  {
                    path: '/merchant/activityManage/list',
                    name: 'ActivityManageList',
                    hideChildrenInMenu: true,
                    component: () => import('@/views/merchant/activityManage/list'),
                    meta: { title: '营销活动', keepAlive: true, permission: ['user'] }
                  },
                  {
                    path: '/merchant/activityManage/addOrUpdate',
                    name: 'ActivityAddOrUpdate',
                    hideChildrenInMenu: true,
                    component: () => import('@/views/merchant/activityManage/addOrUpdate'),
                    meta: { title: '新增/编辑营销活动', keepAlive: false, permission: ['user'] },
                    hidden: true
                  }
                ]
              },
              {
                path: '/merchant/couponUselog',
                component: PageView,
                name: 'CouponUselog',
                hideChildrenInMenu: true,
                meta: { title: '优惠券发券记录', icon: icon['couponUselog'], keepAlive: true, permission: ['admin', 'merchant-couponUselog'] },
                redirect: '/merchant/couponUselog/list',
                children: [
                  {
                    path: '/merchant/couponUselog/list',
                    name: 'CouponUselogList',
                    hideChildrenInMenu: true,
                    component: () => import('@/views/merchant/couponUselog/list'),
                    meta: { title: '优惠券发券记录', keepAlive: true, permission: ['user'] }
                  }
                ]
              }
            ]
          },
          {
            path: '/otherBusiness',
            name: 'OtherBusiness',
            component: RouteView,
            redirect: '/otherBusiness/tempDerateListb/list',
            meta: { title: '其他业务', icon: 'folder-add', keepAlive: true, permission: ['admin', 'otherBusiness-tempDerateListb', 'otherBusiness-yuandianReservation', 'otherBusiness-whitelistpageb', 'otherBusiness-blacklistpageb'] },
            children: [
              {
                path: '/otherBusiness/tempDerateListb',
                component: PageView,
                name: 'TempDerateListb',
                hideChildrenInMenu: true,
                meta: { title: '访客预约管理', icon: icon['tempDerateListb'], keepAlive: true, permission: ['admin', 'otherBusiness-tempDerateListb'] },
                redirect: '/otherBusiness/tempDerateListb/list',
                children: [
                  {
                    path: '/otherBusiness/tempDerateListb/list',
                    name: 'TempDerateListbList',
                    hideChildrenInMenu: true,
                    component: () => import('@/views/otherBusiness/tempDerateListb/list'),
                    meta: { title: '访客预约管理', keepAlive: true, permission: ['user'] }
                  },
                  {
                    path: '/otherBusiness/tempDerateListb/tempDerateImport',
                    name: 'TempDerateImport',
                    hideChildrenInMenu: true,
                    hidden: true,
                    component: () => import('@/views/otherBusiness/tempDerateListb/tempDerateImport'),
                    meta: { title: '访客车辆批量导入', keepAlive: false, permission: ['user'] }
                  }
                ]
              },
              {
                path: '/otherBusiness/yuandianReservation',
                component: PageView,
                name: 'YuandianReservation',
                hideChildrenInMenu: true,
                meta: { title: '源点预约停车记录', icon: icon['yuandianReservation'], keepAlive: true, permission: ['admin', 'otherBusiness-yuandianReservation'] },
                redirect: '/otherBusiness/yuandianReservation/list',
                children: [
                  {
                    path: '/otherBusiness/yuandianReservation/list',
                    name: 'YuandianReservationList',
                    hideChildrenInMenu: true,
                    component: () => import('@/views/otherBusiness/yuandianReservation/list'),
                    meta: { title: '源点预约停车记录', keepAlive: true, permission: ['user'] }
                  }
                ]
              },
              {
                path: '/otherBusiness/whitelistpageb',
                component: PageView,
                name: 'Whitelistpageb',
                hideChildrenInMenu: true,
                meta: { title: '白名单VIP管理', icon: icon['whitelistpageb'], keepAlive: true, permission: ['admin', 'otherBusiness-whitelistpageb'] },
                redirect: '/otherBusiness/whitelistpageb/list',
                children: [
                  {
                    path: '/otherBusiness/whitelistpageb/list',
                    name: 'WhitelistpagebList',
                    hideChildrenInMenu: true,
                    component: () => import('@/views/otherBusiness/whitelistpageb/list'),
                    meta: { title: '白名单VIP管理', keepAlive: true, permission: ['user'] }
                  },
                  {
                    path: '/otherBusiness/whitelistpageb/whitelistImport',
                    name: 'WhitelistImport',
                    hideChildrenInMenu: true,
                    hidden: true,
                    component: () => import('@/views/otherBusiness/whitelistpageb/whitelistImport'),
                    meta: { title: '白名单车辆批量导入', keepAlive: false, permission: ['user'] }
                  }
                ]
              },
              {
                path: '/otherBusiness/blacklistpageb',
                component: PageView,
                name: 'Blacklistpageb',
                hideChildrenInMenu: true,
                meta: { title: '黑名单管理', icon: icon['blacklistpageb'], keepAlive: true, permission: ['admin', 'otherBusiness-blacklistpageb'] },
                redirect: '/otherBusiness/blacklistpageb/list',
                children: [
                  {
                    path: '/otherBusiness/blacklistpageb/list',
                    name: 'BlacklistpagebList',
                    hideChildrenInMenu: true,
                    component: () => import('@/views/otherBusiness/blacklistpageb/list'),
                    meta: { title: '黑名单管理', keepAlive: true, permission: ['user'] }
                  },
                  {
                    path: '/otherBusiness/whitelistpageb/blacklistImport',
                    name: 'BlacklistImport',
                    hideChildrenInMenu: true,
                    hidden: true,
                    component: () => import('@/views/otherBusiness/blacklistpageb/blacklistImport'),
                    meta: { title: '黑名单车辆批量导入', keepAlive: false, permission: ['user'] }
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        path: '/financeCenter',
        name: 'financeCenter',
        component: RouteView,
        redirect: '/settledBill/settleorderb/list',
        meta: { title: '财务管理', icon: icon['financeCenter'], permission: ['admin', 'settledBill-settleorderb', 'settledBill-usingruleb', 'settleb-unsettledparkorderb', 'settleb-unsettledrentorderb', 'settleb-unsettledmerchantorderb', 'refund-refundParking', 'refund-refundRent', 'reconciliation-orderSummary', 'reconciliation-paymentSummary', 'subTrade-wxpayorder', 'subTrade-alipayorder', 'hosting-chargebill', 'hosting-usingbillrule', 'hosting-pendingbillrule'] },
        children: [
          // {
          //   path: '/settledBill',
          //   name: 'settledBill',
          //   component: RouteView,
          //   redirect: '/settledBill/settleorderb/list',
          //   meta: { title: '已结算账单管理', keepAlive: true, permission: ['admin', 'settledBill-settleorderb', 'settledBill-usingruleb'] },
          //   children: [
          //     {
          //       path: '/settledBill/settleorderb',
          //       component: PageView,
          //       name: 'settleorderb',
          //       hideChildrenInMenu: true,
          //       meta: { title: '已结算账单', icon: 'property-safety', keepAlive: true, permission: ['admin', 'settledBill-settleorderb'] },
          //       redirect: '/settledBill/settleorderb/list',
          //       children: [
          //         {
          //           path: '/settledBill/settleorderb/list',
          //           name: 'settleorderbList',
          //           hideChildrenInMenu: true,
          //           component: () => import('@/views/settledBill/settleorderb/list'),
          //           meta: { title: '已结算账单', keepAlive: true, permission: ['user'] }
          //         }
          //       ]
          //     },
          //     {
          //       path: '/settledBill/usingruleb',
          //       component: PageView,
          //       name: 'usingruleb',
          //       hideChildrenInMenu: true,
          //       meta: { title: '结算配置管理', icon: 'setting', keepAlive: true, permission: ['admin', 'settledBill-usingruleb'] },
          //       redirect: '/settledBill/usingruleb/list',
          //       children: [
          //         {
          //           path: '/settledBill/usingruleb/list',
          //           name: 'usingrulebList',
          //           hideChildrenInMenu: true,
          //           component: () => import('@/views/settledBill/usingruleb/list'),
          //           meta: { title: '结算配置管理', keepAlive: true, permission: ['user'] }
          //         }
          //       ]
          //     }
          //   ]
          // },
          // {
          //   path: '/settleb',
          //   name: 'Settleb',
          //   component: RouteView,
          //   redirect: '/settleb/unsettledparkorderb/list',
          //   meta: { title: '待结算订单管理', keepAlive: true, permission: ['admin', 'settleb-unsettledparkorderb', 'settleb-unsettledrentorderb', 'settleb-unsettledmerchantorderb'] },
          //   children: [
          //     {
          //       path: '/settleb/unsettledparkorderb',
          //       component: PageView,
          //       name: 'Unsettledparkorderb',
          //       hideChildrenInMenu: true,
          //       meta: { title: '临停订单', icon: 'file-protect', keepAlive: true, permission: ['admin', 'settleb-unsettledparkorderb'] },
          //       redirect: '/settleb/unsettledparkorderb/list',
          //       children: [
          //         {
          //           path: '/settleb/unsettledparkorderb/list',
          //           name: 'UnsettledparkorderbList',
          //           hideChildrenInMenu: true,
          //           component: () => import('@/views/settleb/unsettledparkorderb/list'),
          //           meta: { title: '临停订单', keepAlive: true, permission: ['user'] }
          //         }
          //       ]
          //     },
          //     {
          //       path: '/settleb/unsettledrentorderb',
          //       component: PageView,
          //       name: 'Unsettledrentorderb',
          //       hideChildrenInMenu: true,
          //       meta: { title: '长租订单', icon: 'file-sync', keepAlive: true, permission: ['admin', 'settleb-unsettledrentorderb'] },
          //       redirect: '/settleb/unsettledrentorderb/list',
          //       children: [
          //         {
          //           path: '/settleb/unsettledrentorderb/list',
          //           name: 'UnsettledrentorderbList',
          //           hideChildrenInMenu: true,
          //           component: () => import('@/views/settleb/unsettledrentorderb/list'),
          //           meta: { title: '长租订单', keepAlive: true, permission: ['user'] }
          //         }
          //       ]
          //     },
          //     {
          //       path: '/settleb/unsettledmerchantorderb',
          //       component: PageView,
          //       name: 'unsettledmerchantorderb',
          //       hideChildrenInMenu: true,
          //       meta: { title: '商户充值订单', icon: 'schedule', keepAlive: true, permission: ['admin', 'settleb-unsettledmerchantorderb'] },
          //       redirect: '/settleb/unsettledmerchantorderb/list',
          //       children: [
          //         {
          //           path: '/settleb/unsettledmerchantorderb/list',
          //           name: 'unsettledmerchantorderbList',
          //           hideChildrenInMenu: true,
          //           component: () => import('@/views/settleb/unsettledmerchantorderb/list'),
          //           meta: { title: '商户充值订单', keepAlive: true, permission: ['user'] }
          //         }
          //       ]
          //     }
          //   ]
          // },
          {
            path: '/refund',
            name: 'Refund',
            component: RouteView,
            redirect: '/refund/refundParking/list',
            meta: { title: '退款管理', icon: 'exception', keepAlive: true, permission: ['admin', 'refund-refundParking', 'refund-refundRent'] },
            children: [
              {
                path: '/refund/refundParking',
                component: PageView,
                name: 'RefundParking',
                hideChildrenInMenu: true,
                meta: { title: '临停车退款', icon: icon['refundParking'], keepAlive: true, permission: ['admin', 'refund-refundParking'] },
                redirect: '/refund/refundParking/list',
                children: [
                  {
                    path: '/refund/refundParking/list',
                    name: 'RefundParkingList',
                    hideChildrenInMenu: true,
                    component: () => import('@/views/refund/refundParking/list'),
                    meta: { title: '临停车退款', keepAlive: true, permission: ['user'] }
                  }
                ]
              },
              {
                path: '/refund/refundRent',
                component: PageView,
                name: 'RefundRent',
                hideChildrenInMenu: true,
                meta: { title: '月租车退款', icon: icon['refundRent'], keepAlive: true, permission: ['admin', 'refund-refundRent'] },
                redirect: '/refund/refundRent/list',
                children: [
                  {
                    path: '/refund/refundRent/list',
                    name: 'RefundRentList',
                    hideChildrenInMenu: true,
                    component: () => import('@/views/refund/refundRent/list'),
                    meta: { title: '月租车退款', keepAlive: true, permission: ['user'] }
                  }
                ]
              }
            ]
          },
          {
            path: '/reconciliation',
            name: 'Reconciliation',
            component: RouteView,
            redirect: '/reconciliation/orderSummary/list',
            meta: { title: '对账管理', icon: 'money-collect', keepAlive: true, permission: ['admin', 'reconciliation-orderSummary', 'reconciliation-paymentSummary'] },
            children: [
              {
                path: '/reconciliation/orderSummary',
                component: PageView,
                name: 'OrderSummary',
                hideChildrenInMenu: true,
                meta: { title: '支付订单查询', icon: 'profile', keepAlive: true, permission: ['admin', 'reconciliation-orderSummary'] },
                redirect: '/reconciliation/orderSummary/list',
                children: [
                  {
                    path: '/reconciliation/orderSummary/list',
                    name: 'OrderSummaryList',
                    hideChildrenInMenu: true,
                    component: () => import('@/views/reconciliation/orderSummary/list'),
                    meta: { title: '支付订单查询', keepAlive: true, permission: ['user'] }
                  }
                ]
              },
              {
                path: '/reconciliation/paymentSummary',
                component: PageView,
                name: 'PaymentSummary',
                hideChildrenInMenu: true,
                meta: { title: '支付账单明细', icon: icon['paymentSummary'], keepAlive: true, permission: ['admin', 'reconciliation-paymentSummary'] },
                redirect: '/reconciliation/paymentSummary/list',
                children: [
                  {
                    path: '/reconciliation/paymentSummary/list',
                    name: 'PaymentSummaryList',
                    hideChildrenInMenu: true,
                    component: () => import('@/views/reconciliation/paymentSummary/list'),
                    meta: { title: '支付账单明细', keepAlive: true, permission: ['user'] }
                  }
                ]
              }
            ]
          }
          // {
          //   path: '/subTrade',
          //   name: 'SubTrade',
          //   component: RouteView,
          //   redirect: '/subTrade/wxpayorder/list',
          //   meta: { title: '第三方服务商结算订单', keepAlive: true, permission: ['admin', 'subTrade-wxpayorder', 'subTrade-alipayorder'] },
          //   children: [
          //     {
          //       path: '/subTrade/wxpayorder',
          //       component: PageView,
          //       name: 'Wxpayorder',
          //       hideChildrenInMenu: true,
          //       meta: { title: '微信订单', icon: 'wechat', keepAlive: true, permission: ['admin', 'subTrade-wxpayorder'] },
          //       redirect: '/subTrade/wxpayorder/list',
          //       children: [
          //         {
          //           path: '/subTrade/wxpayorder/list',
          //           name: 'WxpayorderList',
          //           hideChildrenInMenu: true,
          //           component: () => import('@/views/subTrade/wxpayorder/list'),
          //           meta: { title: '微信订单', keepAlive: true, permission: ['user'] }
          //         }
          //       ]
          //     },
          //     {
          //       path: '/subTrade/alipayorder',
          //       component: PageView,
          //       name: 'Alipayorder',
          //       hideChildrenInMenu: true,
          //       meta: { title: '支付宝订单', icon: 'alipay', keepAlive: true, permission: ['admin', 'subTrade-alipayorder'] },
          //       redirect: '/subTrade/alipayorder/list',
          //       children: [
          //         {
          //           path: '/subTrade/alipayorder/list',
          //           name: 'AlipayorderList',
          //           hideChildrenInMenu: true,
          //           component: () => import('@/views/subTrade/alipayorder/list'),
          //           meta: { title: '支付宝订单', keepAlive: true, permission: ['user'] }
          //         }
          //       ]
          //     }
          //   ]
          // },
          // {
          //   path: '/hosting',
          //   name: 'Hosting',
          //   component: RouteView,
          //   redirect: '/hosting/chargebill/list',
          //   meta: { title: '车道托管服务费账单', keepAlive: true, permission: ['admin', 'hosting-chargebill', 'hosting-usingbillrule', 'hosting-pendingbillrule'] },
          //   children: [
          //     {
          //       path: '/hosting/chargebill',
          //       component: PageView,
          //       name: 'Chargebill',
          //       hideChildrenInMenu: true,
          //       meta: { title: '服务费账单', icon: 'red-envelope', keepAlive: true, permission: ['admin', 'hosting-chargebill'] },
          //       redirect: '/hosting/chargebill/list',
          //       children: [
          //         {
          //           path: '/hosting/chargebill/list',
          //           name: 'ChargebillList',
          //           hideChildrenInMenu: true,
          //           component: () => import('@/views/hosting/chargebill/list'),
          //           meta: { title: '服务费账单', keepAlive: true, permission: ['user'] }
          //         }
          //       ]
          //     },
          //     {
          //       path: '/hosting/usingbillrule',
          //       component: PageView,
          //       name: 'Usingbillrule',
          //       hideChildrenInMenu: true,
          //       meta: { title: '服务费配置管理', icon: 'shop', keepAlive: true, permission: ['admin', 'hosting-usingbillrule'] },
          //       redirect: '/hosting/usingbillrule/list',
          //       children: [
          //         {
          //           path: '/hosting/usingbillrule/list',
          //           name: 'UsingbillruleList',
          //           hideChildrenInMenu: true,
          //           component: () => import('@/views/hosting/usingbillrule/list'),
          //           meta: { title: '服务费配置管理', keepAlive: true, permission: ['user'] }
          //         }
          //       ]
          //     },
          //     {
          //       path: '/hosting/pendingbillrule',
          //       component: PageView,
          //       name: 'Pendingbillrule',
          //       hideChildrenInMenu: true,
          //       meta: { title: '服务费审核管理', icon: 'audit', keepAlive: true, permission: ['admin', 'hosting-pendingbillrule'] },
          //       redirect: '/hosting/pendingbillrule/list',
          //       children: [
          //         {
          //           path: '/hosting/pendingbillrule/list',
          //           name: 'PendingbillruleList',
          //           hideChildrenInMenu: true,
          //           component: () => import('@/views/hosting/pendingbillrule/list'),
          //           meta: { title: '服务费审核管理', keepAlive: true, permission: ['user'] }
          //         }
          //       ]
          //     }
          //   ]
          // }
        ]
      },
      {
        path: '/eaeCenter',
        name: 'EaeCenter',
        component: RouteView,
        redirect: '/runService/parkingQrCode/list',
        meta: { title: '运维监测', icon: icon['eaeCenter'], permission: ['admin', 'runService-parkingQrCode', 'runService-barrierAuthListb', 'runService-groupFeeListb', 'runService-surveillanceCar', 'runService-cloudBarrier', 'monitor-clientInfo', 'monitor-updownb', 'monitor-feedbackb', 'monitor-surveillance', 'monitor-fakeCarNum', 'monitor-vehicleUTurn', 'monitor-vehicleCongestion', 'monitor-traceCarEventList', 'monitor-clonedCar', 'monitor-operb'] },
        children: [
          // {
          //   path: '/runService',
          //   name: 'RunService',
          //   component: RouteView,
          //   redirect: '/runService/parkingQrCode/list',
          //   meta: { title: '运维管理', keepAlive: true, permission: ['admin', 'runService-parkingQrCode', 'runService-barrierAuthListb', 'runService-groupFeeListb', 'runService-surveillanceCar', 'runService-cloudBarrier'] },
          //   children: [
          //     {
          //       path: '/runService/parkingQrCode',
          //       component: PageView,
          //       name: 'ParkingQrCode',
          //       hideChildrenInMenu: true,
          //       meta: { title: '车场二维码下载', icon: 'qrcode', keepAlive: true, permission: ['admin', 'runService-parkingQrCode'] },
          //       redirect: '/runService/parkingQrCode/list',
          //       children: [
          //         {
          //           path: '/runService/parkingQrCode/list',
          //           name: 'ParkingQrCodeList',
          //           hideChildrenInMenu: true,
          //           component: () => import('@/views/runService/parkingQrCode/list'),
          //           meta: { title: '车场二维码下载', keepAlive: true, permission: ['user'] }
          //         }
          //       ]
          //     },
          //     {
          //       path: '/runService/barrierAuthListb',
          //       component: PageView,
          //       name: 'BarrierAuthListb',
          //       hideChildrenInMenu: true,
          //       meta: { title: '车道通行权限', icon: 'deployment-unit', keepAlive: true, permission: ['admin', 'runService-barrierAuthListb'] },
          //       redirect: '/runService/barrierAuthListb/list',
          //       children: [
          //         {
          //           path: '/runService/barrierAuthListb/list',
          //           name: 'BarrierAuthListbList',
          //           hideChildrenInMenu: true,
          //           component: () => import('@/views/runService/barrierAuthListb/list'),
          //           meta: { title: '车道通行权限', keepAlive: true, permission: ['user'] }
          //         }
          //       ]
          //     },
          //     // {
          //     //   path: '/runService/groupFeeListb',
          //     //   component: PageView,
          //     //   name: 'GroupFeeListb',
          //     //   hideChildrenInMenu: true,
          //     //   meta: { title: '分组计费管理', icon: 'team', keepAlive: true, permission: ['admin', 'runService-groupFeeListb'] },
          //     //   redirect: '/runService/groupFeeListb/list',
          //     //   children: [
          //     //     {
          //     //       path: '/runService/groupFeeListb/list',
          //     //       name: 'GroupFeeListbList',
          //     //       hideChildrenInMenu: true,
          //     //       component: () => import('@/views/runService/groupFeeListb/list'),
          //     //       meta: { title: '分组计费管理', keepAlive: true, permission: ['user'] }
          //     //     },
          //     //     {
          //     //       path: '/runService/groupFeeListb/carOwnerList',
          //     //       name: 'CarOwnerList',
          //     //       hideChildrenInMenu: true,
          //     //       hidden: true,
          //     //       component: () => import('@/views/runService/groupFeeListb/carOwnerList'),
          //     //       meta: { title: '车主管理', keepAlive: false, permission: ['user'] }
          //     //     },
          //     //     {
          //     //       path: '/runService/groupFeeListb/addCarList',
          //     //       name: 'AddCarList',
          //     //       hideChildrenInMenu: true,
          //     //       hidden: true,
          //     //       component: () => import('@/views/runService/groupFeeListb/addCarList'),
          //     //       meta: { title: '车辆管理', keepAlive: false, permission: ['user'] }
          //     //     }
          //     //   ]
          //     // },
          //     {
          //       path: '/runService/surveillanceCar',
          //       component: PageView,
          //       name: 'SurveillanceCar',
          //       hideChildrenInMenu: true,
          //       meta: { title: '布控车辆管理', icon: 'project', keepAlive: true, permission: ['admin', 'runService-surveillanceCar'] },
          //       redirect: '/runService/surveillanceCar/list',
          //       children: [
          //         {
          //           path: '/runService/surveillanceCar/list',
          //           name: 'SurveillanceCarList',
          //           hideChildrenInMenu: true,
          //           component: () => import('@/views/runService/surveillanceCar/list'),
          //           meta: { title: '布控车辆管理', keepAlive: true, permission: ['user'] }
          //         }
          //       ]
          //     },
          //     {
          //       path: '/runService/cloudBarrier',
          //       component: PageView,
          //       name: 'CloudBarrier',
          //       hideChildrenInMenu: true,
          //       meta: { title: '云道闸管理', icon: 'cloud-server', keepAlive: true, permission: ['admin', 'runService-cloudBarrier'] },
          //       redirect: '/runService/cloudBarrier/list',
          //       children: [
          //         {
          //           path: '/runService/cloudBarrier/list',
          //           name: 'CloudBarrierList',
          //           hideChildrenInMenu: true,
          //           component: () => import('@/views/runService/cloudBarrier/list'),
          //           meta: { title: '云道闸管理', keepAlive: true, permission: ['user'] }
          //         }
          //       ]
          //     }
          //   ]
          // },
          {
            path: '/monitor',
            name: 'Monitor',
            component: RouteView,
            redirect: '/monitor/clientInfo/list',
            meta: { title: '场库事件全域监测', icon: 'radar-chart', keepAlive: true, permission: ['admin', 'monitor-clientInfo', 'monitor-updownb', 'monitor-feedbackb', 'monitor-surveillance', 'monitor-fakeCarNum', 'monitor-vehicleUTurn', 'monitor-vehicleCongestion', 'monitor-traceCarEventList', 'monitor-clonedCar', 'monitor-operb'] },
            children: [
              // {
              //   path: '/monitor/clientInfo',
              //   component: PageView,
              //   name: 'ClientInfo',
              //   hideChildrenInMenu: true,
              //   meta: { title: '设备实时运行监测', icon: 'build', keepAlive: true, permission: ['admin', 'monitor-clientInfo'] },
              //   redirect: '/monitor/clientInfo/list',
              //   children: [
              //     {
              //       path: '/monitor/clientInfo/list',
              //       name: 'ClientInfoList',
              //       hideChildrenInMenu: true,
              //       component: () => import('@/views/monitor/clientInfo/list'),
              //       meta: { title: '设备实时运行监测', keepAlive: true, permission: ['user'] }
              //     }
              //   ]
              // },
              {
                path: '/monitor/updownb',
                component: PageView,
                name: 'Updownb',
                hideChildrenInMenu: true,
                meta: { title: '异常抬杆事件监测', icon: icon['updownb'], keepAlive: true, permission: ['admin', 'monitor-updownb'] },
                redirect: '/monitor/updownb/list',
                children: [
                  {
                    path: '/monitor/updownb/list',
                    name: 'UpdownbList',
                    hideChildrenInMenu: true,
                    component: () => import('@/views/monitor/updownb/list'),
                    meta: { title: '异常抬杆事件监测', keepAlive: true, permission: ['user'] }
                  }
                ]
              },
              // {
              //   path: '/monitor/surveillance',
              //   component: PageView,
              //   name: 'Surveillance',
              //   hideChildrenInMenu: true,
              //   meta: { title: '布控车辆触发监测', icon: 'read', keepAlive: true, permission: ['admin', 'monitor-surveillance'] },
              //   redirect: '/monitor/surveillance/list',
              //   children: [
              //     {
              //       path: '/monitor/surveillance/list',
              //       name: 'SurveillanceList',
              //       hideChildrenInMenu: true,
              //       component: () => import('@/views/monitor/surveillance/list'),
              //       meta: { title: '布控车辆触发监测', keepAlive: true, permission: ['user'] }
              //     }
              //   ]
              // },
              // {
              //   path: '/monitor/fakeCarNum',
              //   component: PageView,
              //   name: 'FakeCarNum',
              //   hideChildrenInMenu: true,
              //   meta: { title: '假车牌触发监测', icon: 'read', keepAlive: true, permission: ['admin', 'monitor-fakeCarNum'] },
              //   redirect: '/monitor/fakeCarNum/list',
              //   children: [
              //     {
              //       path: '/monitor/fakeCarNum/list',
              //       name: 'FakeCarNumList',
              //       hideChildrenInMenu: true,
              //       component: () => import('@/views/monitor/fakeCarNum/list'),
              //       meta: { title: '假车牌触发监测', keepAlive: true, permission: ['user'] }
              //     }
              //   ]
              // },
              // {
              //   path: '/monitor/vehicleUTurn',
              //   component: PageView,
              //   name: 'VehicleUTurn',
              //   hideChildrenInMenu: true,
              //   meta: { title: '折返事件监测', icon: 'read', keepAlive: true, permission: ['admin', 'monitor-vehicleUTurn'] },
              //   redirect: '/monitor/vehicleUTurn/list',
              //   children: [
              //     {
              //       path: '/monitor/vehicleUTurn/list',
              //       name: 'VehicleUTurnList',
              //       hideChildrenInMenu: true,
              //       component: () => import('@/views/monitor/vehicleUTurn/list'),
              //       meta: { title: '折返事件监测', keepAlive: true, permission: ['user'] }
              //     }
              //   ]
              // },
              // {
              //   path: '/monitor/vehicleCongestion',
              //   component: PageView,
              //   name: 'VehicleCongestion',
              //   hideChildrenInMenu: true,
              //   meta: { title: '溜车事件监测', icon: 'read', keepAlive: true, permission: ['admin', 'monitor-vehicleCongestion'] },
              //   redirect: '/monitor/vehicleCongestion/list',
              //   children: [
              //     {
              //       path: '/monitor/vehicleCongestion/list',
              //       name: 'VehicleCongestionList',
              //       hideChildrenInMenu: true,
              //       component: () => import('@/views/monitor/vehicleCongestion/list'),
              //       meta: { title: '溜车事件监测', keepAlive: true, permission: ['user'] }
              //     }
              //   ]
              // },
              // {
              //   path: '/monitor/traceCarEventList',
              //   component: PageView,
              //   name: 'TraceCarEvent',
              //   hideChildrenInMenu: true,
              //   meta: { title: '跟车事件监测', icon: 'car', keepAlive: true, permission: ['admin', 'monitor-traceCarEventList'] },
              //   redirect: '/monitor/traceCarEventList/list',
              //   children: [
              //     {
              //       path: '/monitor/traceCarEventList/list',
              //       name: 'TraceCarEventList',
              //       hideChildrenInMenu: true,
              //       component: () => import('@/views/monitor/traceCarEventList/list'),
              //       meta: { title: '跟车事件监测', keepAlive: true, permission: ['user'] }
              //     }
              //   ]
              // },
              // {
              //   path: '/monitor/clonedCar',
              //   component: PageView,
              //   name: 'ClonedCar',
              //   hideChildrenInMenu: true,
              //   meta: { title: '疑似套牌触发监测', icon: 'car', keepAlive: true, permission: ['admin', 'monitor-clonedCar'] },
              //   redirect: '/monitor/clonedCar/list',
              //   children: [
              //     {
              //       path: '/monitor/clonedCar/list',
              //       name: 'ClonedCarList',
              //       hideChildrenInMenu: true,
              //       component: () => import('@/views/monitor/clonedCar/list'),
              //       meta: { title: '疑似套牌触发监测', keepAlive: true, permission: ['user'] }
              //     }
              //   ]
              // },
              {
                path: '/monitor/loginLogb',
                component: PageView,
                name: 'LoginLogb',
                hideChildrenInMenu: true,
                meta: { title: '登录行为监测', icon: 'login', keepAlive: false, permission: ['admin'] },
                redirect: '/monitor/loginLogb/list',
                children: [
                  {
                    path: '/monitor/loginLogb/list',
                    name: 'LoginLogbList',
                    hideChildrenInMenu: true,
                    component: () => import('@/views/monitor/loginLogb/list'),
                    meta: { title: '登录行为监测', keepAlive: false, permission: ['user'] }
                  }
                ]
              },
              {
                path: '/monitor/feedbackb',
                component: PageView,
                name: 'Feedbackb',
                hideChildrenInMenu: true,
                meta: { title: '问题反馈', icon: 'reconciliation', keepAlive: false, permission: ['admin', 'monitor-feedbackb'] },
                redirect: '/monitor/feedbackb/list',
                children: [
                  {
                    path: '/monitor/feedbackb/list',
                    name: 'FeedbackbList',
                    hideChildrenInMenu: true,
                    component: () => import('@/views/monitor/feedbackb/list'),
                    meta: { title: '问题反馈', keepAlive: true, permission: ['user'] }
                  }
                ]
              }
              // {
              //   path: '/monitor/operb',
              //   component: PageView,
              //   name: 'Operb',
              //   hideChildrenInMenu: true,
              //   meta: { title: '操作行为监测', icon: 'table', keepAlive: true, permission: ['admin', 'monitor-operb'] },
              //   redirect: '/monitor/operb/list',
              //   children: [
              //     {
              //       path: '/monitor/operb/list',
              //       name: 'OperbList',
              //       hideChildrenInMenu: true,
              //       component: () => import('@/views/monitor/operb/list'),
              //       meta: { title: '操作行为监测', keepAlive: true, permission: ['user'] }
              //     }
              //   ]
              // }
            ]
          }
        ]
      },
      {
        path: '/control',
        name: 'ControlManage',
        component: RouteView,
        redirect: '/videoControl',
        meta: { title: '岗亭管理', icon: icon['videoControl'], permission: ['admin', 'control-videoControl'] },
        children: [
          {
            path: '/videoControl',
            name: 'RunService',
            redirect: '/control/videoControl',
            meta: { title: '云岗亭', icon: icon['videoControl'], keepAlive: false, permission: ['user'] }
          }
        ]
      },
      {
        path: '/coupon',
        name: 'CouponManageWeb',
        component: RouteView,
        redirect: '/couponManage/coupon',
        meta: { title: '发券平台', icon: icon['couponSent'], permission: ['admin', 'coupon-manage'] },
        children: [
          {
            path: '/couponManage/coupon',
            name: 'Coupon',
            meta: { title: '发券平台', keepAlive: false, permission: ['user'] }
          }
        ]
      }
    ]
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
]

export const singelRouterMap = [
  {
    path: '/controls',
    name: 'Control',
    component: BlankLayout,
    redirect: '/control/videoControl',
    meta: { title: '岗亭管理', icon: icon['videoControl'], permission: ['admin', 'control-videoControl'] },
    children: [
      {
        path: '/control/videoControl',
        name: 'VideoControl',
        component: () => import('@/views/videoControl/index'),
        meta: { title: '云岗亭', icon: icon['videoControl'], keepAlive: false, permission: ['admin', 'control-videoControl'] }
      }
    ]
  }
]

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/user',
    name: 'loginPage',
    component: UserLayout,
    redirect: '/user/login',
    hidden: true,
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/Login')
      }
    ]
  },
  {
    path: '/404',
    component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/404')
  },
  {
    path: '/flv-player',
    name: 'flvPlayer',
    component: () => import('@/views/videoPlayer.vue')
  }
]
